import { LOGOUT, SET_MEAL_ORDERS_LIST, SET_UNSETTLED_MEAL_ORDERS_LIST } from "../actions/types";

const INITIAL_STATE = {
    list: [],
    unsettled: [],
    pages: null,
    year: null,
    month: null
};

const mealOrderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_MEAL_ORDERS_LIST:
            return {
                ...state,
                list: action.payload.mealOrders.map(mealOrder => {
                    return {
                        orderID: mealOrder.orderID,
                        userID: mealOrder.userID,
                        totalPrice: mealOrder.totalPrice,
                        foundedPrice: mealOrder.foundedPrice,
                        submitedOn: mealOrder.submitedOn,
                        canceled: mealOrder.canceled,
                        canceledOn: mealOrder.canceledOn,
                        accepted: mealOrder.accepted,
                        acceptedOn: mealOrder.acceptedOn,
                        reportID: mealOrder.reportID,
                        fname: mealOrder.fname,
                        lname: mealOrder.lname,
                        email: mealOrder.email,
                        ouID: mealOrder.ouID,
                        ouName: mealOrder.ouName,
                        rows: mealOrder.rows.map(row => ({
                            posID: row.posID,
                            mealID: row.mealID,
                            mealDescription: row.mealDescription
                        }))
                    };
                }),
                pages: action.payload.pages,
                year: action.payload.year ? action.payload.year : null,
                month: action.payload.month ? action.payload.month : null
            };
        case SET_UNSETTLED_MEAL_ORDERS_LIST:
            return {
                ...state,
                unsettled: action.payload.map(mealOrder => {
                    return {
                        day: mealOrder.day,
                        count: mealOrder.count
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default mealOrderReducer;